import { axiosPrivate } from 'shared/api';
import { IProductWarehouse } from 'features/inventory/products/types';
import { BaseService } from 'shared/services/BaseService';

class ProductWarehouseService extends BaseService<IProductWarehouse> {
  constructor() {
    super('warehouse-products');
  }
  canDelete = true;

  createUnifiedInstance = async (values: Record<string, unknown>) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/create-unified-instance/`, values);
    return res.data;
  };

  updateThresholds = async (thresholds: any[]) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/update-thresholds/`, {
      product_warehouses: thresholds
    });
    return res.data;
  };

  setDefaultLocation = async (
    product: string,
    warehouse: string,
    defaultLocation?: number | ''
  ) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/set-default-location/`, {
      product,
      warehouse,
      default_location: defaultLocation || null
    });
    return res.data;
  };

  importFromFileDetail = async (
    importFile: File,
    warehouseId: number,
    attachmentName = 'import_file'
  ) => {
    const res = await axiosPrivate.postForm(`warehouses/${warehouseId}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };

  bulkDeleteByProduct = async (productId: number) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/bulk-delete-product/`, {
      product: productId
    });
    return res.data;
  };

  bulkDeleteWarehouse = async (warehouseId: number) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/bulk-delete-warehouse/`, {
      warehouse: warehouseId
    });
    return res.data;
  };

  addCostLink = async (productWarehouseId: number, values: Record<string, unknown>) => {
    const res = await axiosPrivate.post(
      `${this.modulePrefix}/${productWarehouseId}/add-cost-link/`,
      values
    );
    return res.data;
  };

  removeCostLink = async (productWarehouseId: number, values: Record<string, unknown>) => {
    const res = await axiosPrivate.post(
      `${this.modulePrefix}/${productWarehouseId}/remove-cost-link/`,
      values
    );
    return res.data;
  };

  removeExam = async (productWarehouseId: number, examId: number) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/${productWarehouseId}/remove-exam/`, {
      exam: examId
    });
    return res.data;
  };

  importCostsFromFile = async (
    importFile: File,
    warehouseId: number,
    attachmentName = 'import_costs_file'
  ) => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-costs-from-file/`, {
      warehouse: warehouseId,
      [attachmentName]: importFile
    });
    return res.data;
  };

  getCostsImportTemplate = async () => {
    axiosPrivate
      .get(`${this.modulePrefix}/costs-import-template/`, {
        responseType: 'blob'
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition?.indexOf('attachment') !== -1) {
          const filenameMatches = contentDisposition.match(
            /(?:.*filename\*|filename)=(?:([^'"]*)''|("))([^;]+)\2(?:[;`\n]|$)/
          );
          const filename = filenameMatches.pop();
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  };
}

export const productWarehouseService = new ProductWarehouseService();
